export default __webpack_public_path__ + "static/media/NMAH.AC.0433_ref11923.06cfd38d.jpg";